import { render, staticRenderFns } from "./ui-date.vue?vue&type=template&id=45a553fc&scoped=true"
import script from "./ui-date.vue?vue&type=script&lang=js"
export * from "./ui-date.vue?vue&type=script&lang=js"
import style0 from "./ui-date.vue?vue&type=style&index=0&id=45a553fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a553fc",
  null
  
)

export default component.exports